<div class="container-fluid p-0">

  <div class="alert alert-warning m-3" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view users.
    Please contact your administrator to request access.
  </div>

  <ng-container *ngIf="canView">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <a class="navbar-brand" href="javascript:void(0)">Related Users</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <span class="mr-auto">
          <ng-container *ngIf="canManage">
            <button
              class="m-1 mr-2"
              type="button"
              color="primary"
              mat-raised-button
              (click)="onManageUsers()"
              matTooltip="Click this button to sync users.">
              <mat-icon>account_circle</mat-icon>
              Manage Users
            </button>
          </ng-container>
        </span>

        <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
          <mat-icon>filter_list</mat-icon> Filter
        </button>

        <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
          <input
            class="form-control ml-0 mr-2 my-1"
            type="search"
            [(ngModel)]="dataSource.search"
            name="search"
            placeholder="Search"
            aria-label="Search"
            id="search-input"
            matTooltip="Search the users by name, email, mobile or job title."/>

          <button
            mat-raised-button
            color="secondary"
            type="submit"
            class="mx-0 my-1"
            id="search-button"
            matTooltip="Click this button to run the current search.">
            <mat-icon>search</mat-icon> Search
          </button>
        </form>
      </div>
    </nav>

    <div class="mat-elevation-z8 scroll-box">
      <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

      <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

        <!-- Multiple item selector for lists. -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
              [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
              [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
              matTooltip="Toggle select all records.">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let user">
            <mat-checkbox (click)="$event.stopPropagation()"
              (change)="$event ? dataSource.selection.toggle(user.id) : null"
              [checked]="dataSource.selection.isSelected(user.id)"
              matTooltip="Toggle select this record.">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- The ID of the user. -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the user.">
            ID #
          </th>
          <td mat-cell *matCellDef="let user">
            {{ user.id }}
          </td>
        </ng-container>

        <!-- Full Name -->
        <ng-container matColumnDef="contact_person">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the full name of the user.">
            Full Name
          </th>
          <td mat-cell *matCellDef="let user" class="text-wrap">
            <a (click)="onUserPublicView(user.hash)"
               matTooltip="View User Public Profile">
              {{ user.contact_person }}
            </a>
          </td>
        </ng-container>

        <!-- Email Address -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the email address of the user.">
            Email Address
          </th>
          <td mat-cell *matCellDef="let user">
            {{ user.email }}
          </td>
        </ng-container>

        <!-- Mobile Number -->
        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }} of the user.">
            {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}
          </th>
          <td mat-cell *matCellDef="let user">
            {{ user.mobile }}
          </td>
        </ng-container>

        <!-- Trade -->
        <ng-container matColumnDef="trade">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the job title of the user.">
            Job Title
          </th>
          <td mat-cell *matCellDef="let user">
            {{ user.trade }}
          </td>
        </ng-container>

        <!-- Date the user was enrolled. -->
        <ng-container matColumnDef="date_created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the user was enrolled.">
            Date Enrolled
          </th>
          <td mat-cell *matCellDef="let user">
            {{ (user.date_created * 1000) | timezoneConvertMedium }}
          </td>
        </ng-container>

        <!-- UTC Date the user was enrolled. -->
        <ng-container matColumnDef="date_created_UTC">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the user was enrolled.">
            Date Enrolled (UTC)
          </th>
          <td mat-cell *matCellDef="let user">
            {{ (user.date_created * 1000) | timezoneConvertUTCMedium }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>
          <td mat-cell *matCellDef="let user">
            <ng-container *ngIf="canSendMessage">
              <button type="button" mat-button (click)="onSendMessage(user.id)">
                Send Message
              </button>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
      </table>

      <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
  </ng-container>

</div>
